import { render, staticRenderFns } from "./CheckpointInspectionStatusBadge.vue?vue&type=template&id=f648bcb6&scoped=true"
import script from "./CheckpointInspectionStatusBadge.vue?vue&type=script&lang=js"
export * from "./CheckpointInspectionStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./CheckpointInspectionStatusBadge.vue?vue&type=style&index=0&id=f648bcb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f648bcb6",
  null
  
)

export default component.exports